import { PARSER_CONFIG, REGEX_PATTERNS } from '../constants';
import { TreeNode } from '../types';

import { BaseParser } from './BaseParser';

export class SpaceIndentedParser extends BaseParser {
  readonly name = 'SpaceIndentedParser';

  canParse(input: string): boolean {
    if (input.includes('\t')) return false;

    const lines = input.split('\n', PARSER_CONFIG.maxLinesToCheck);
    return lines.some((line) => REGEX_PATTERNS.whitespace.test(line));
  }

  protected parseInternal(input: string): TreeNode[] {
    const lines = input.split('\n');
    const indentSize = this.detectIndentSize(lines);
    return this.buildHierarchy(
      lines,
      (line) => this.getIndentLevel(line, indentSize),
      (line) => line.trim()
    );
  }

  private getIndentLevel(line: string, indentSize: number): number {
    let spaces = 0;
    for (const char of line) {
      if (char === ' ') {
        spaces++;
      } else {
        break;
      }
    }

    if (spaces === 0) return 0;
    if (spaces === 1) return 0;
    return Math.floor(spaces / indentSize);
  }
}
